/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService
 */
import * as References from './BookmarksChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService#addBookmark
 */
export const ADD_BOOKMARK_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_BookmarksChirpService_addBookmark';
export const ADD_BOOKMARK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_BOOKMARK_MUTATION_FIELD_NAME,
  args: ['assetId', 'containerType'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.addBookmarkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService#removeBookmark
 */
export const REMOVE_BOOKMARK_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_BookmarksChirpService_removeBookmark';
export const REMOVE_BOOKMARK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REMOVE_BOOKMARK_MUTATION_FIELD_NAME,
  args: ['assetId', 'containerType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.removeBookmarkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});